import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import openEye from "../../../assets/openEye.png";
import closeEye from "../../../assets/closeEye.png";
import { URLS } from "../../../Utils/App_urls.js";
import axios from "axios";
import "./Setting.css";
import { errorPopup, successPopup } from "../../../Utils/ToasterMessage";
import { Oval } from "react-loader-spinner";

export default function ResetPassword() {
  const [eyeToggle, setEyeToggle] = useState({
    password: false,
    confirmPassword: false,
  });
  const [password, setPassword] = useState({
    password: "",
    confirmPassword: "",
  });
  const [error, setError] = useState({
    password: "",
    confirmPassword: "",
  });
  const [changePasswordLoader, setChangePasswordLoader] = useState(false);

  const handleEyeToggle = (type) => {
    setEyeToggle((prev) => ({ ...prev, [type]: !prev[type] }));
  };

  const handlePasswordChange = (type, e) => {
    setPassword((prev) => ({ ...prev, [type]: e.target.value }));
    setError({ ...error, [type]: "" });
  };

  const handleReset = () => {
    setPassword({ password: "", confirmPassword: "" });
    setError({ password: "", confirmPassword: "" });
  };

  function validatePasswords() {
    const passwordRegex =
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/;
    let isValid = true;

    if (!password.password) {
      setError((prev) => ({
        ...prev,
        password: "Password is required",
      }));
      isValid = false;
    } else if (!passwordRegex.test(password.password)) {
      setError((prev) => ({
        ...prev,
        password:
          "Password must have at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character.",
      }));
      isValid = false;
    }

    if (!password.confirmPassword) {
      setError((prev) => ({
        ...prev,
        confirmPassword: "Please confirm your password",
      }));
      isValid = false;
    } else if (password.password !== password.confirmPassword) {
      setError((prev) => ({
        ...prev,
        confirmPassword: "Passwords do not match",
      }));
      isValid = false;
    }

    return isValid;
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validatePasswords()) {
      setChangePasswordLoader(true);
      axios
        .post(
          `${URLS.change_password}`,
          {
            password: password.password,
            confirmPassword: password.confirmPassword,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
          }
        )
        .then((res) => {
          successPopup(res?.data?.message);
          setPassword({ password: "", confirmPassword: "" });
        })
        .catch((err) => {
          errorPopup(err?.response?.data?.message);
        })
        .finally(() => setChangePasswordLoader(false));
    }
  };

  return (
    <>
      <div>
        <div className="reset-pass-title">
          <h1>Change Password</h1>
          <p>Change your password for security purposes</p>
        </div>
        <form onSubmit={handleSubmit} className="form-wrapper">
          <label htmlFor="password" className="mt-3 mb-1">
            New Password
          </label>
          <div>
            <input
              type={eyeToggle?.password ? "text" : "password"}
              placeholder="Enter your New Password"
              value={password.password}
              onChange={(e) => handlePasswordChange("password", e)}
              id="password"
            />
            <img
              onClick={() => handleEyeToggle("password")}
              src={eyeToggle?.password ? openEye : closeEye}
              alt="toggleEye"
            />
          </div>
          {error?.password && (
            <p className="text-danger m-0">{error?.password}</p>
          )}
          <label htmlFor="confirmPassword" className="mt-3 mb-1">
            Confirm Password
          </label>
          <div>
            <input
              type={eyeToggle?.confirmPassword ? "text" : "password"}
              placeholder="Confirm your New Password"
              value={password.confirmPassword}
              onChange={(e) => handlePasswordChange("confirmPassword", e)}
              id="confirmPassword"
            />
            <img
              onClick={() => handleEyeToggle("confirmPassword")}
              src={eyeToggle?.confirmPassword ? openEye : closeEye}
              alt="toggleEye"
            />
          </div>
          {error?.confirmPassword && (
            <p className="text-danger m-0">{error?.confirmPassword}</p>
          )}
        </form>
        <div className="btn_group_reset d-flex gap-sm-5 gap-3 justify-content-between align-items-center mt-5 flex-wrap border-0 p-0">
          <button type="button" onClick={handleReset}>
            Cancel
          </button>
          <button
            className="d-flex align-items-center justify-content-center gap-3"
            type="submit"
            onClick={handleSubmit}
            disabled={changePasswordLoader}
          >
            <span
              style={{ display: "inline-block", width: "20px", height: "20px" }}
            >
              {changePasswordLoader && (
                <Oval width={25} height={25} strokeWidth={3} color="#fff" />
              )}
            </span>
            Save Changes
          </button>
        </div>
      </div>
    </>
  );
}
